import { render, staticRenderFns } from "./ReturnDeny.vue?vue&type=template&id=29c83a73&scoped=true"
import script from "./ReturnDeny.vue?vue&type=script&lang=js"
export * from "./ReturnDeny.vue?vue&type=script&lang=js"
import style0 from "./ReturnDeny.vue?vue&type=style&index=0&id=29c83a73&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c83a73",
  null
  
)

export default component.exports